import React, { useState } from 'react';
import { ActivityIndicator } from './activity-indicator';
import {
  CachedImage,
  CachedImageProps,
} from '@usepepper/ui/atoms/cached-image';
import { StyleSheet, View } from 'react-native';

export const ImageWithLoading: React.FC<CachedImageProps> = (props) => {
  const [loading, setLoading] = useState(true);

  return (
    <View style={styles.base}>
      <ActivityIndicator animating={loading} style={styles.activityIndicator} />
      <CachedImage
        alt={props.alt ?? ''}
        {...props}
        onLoadEnd={() => setLoading(false)}
        style={props.style}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  activityIndicator: {
    bottom: 0,
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
  },
  base: {
    flex: 1,
  },
});
